export default __webpack_public_path__ + "assets/future.da9e4f5525153763e9858588c96dd06e.png";